import React from 'react'

/**
 * Card-shaped wrapper using the same surface tokens as real cards in the
 * app (bg-card + border-border-subtle). Children are the layout-specific
 * placeholders (SkeletonText, SkeletonBlock, etc.).
 */
function SkeletonCard({ className = '', children }) {
  return (
    <div
      className={`bg-card rounded-lg border border-border-subtle p-4 sm:p-5 ${className}`}
      aria-hidden="true"
    >
      {children}
    </div>
  )
}

export default SkeletonCard
